import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import jobsApiService from "../services/jobsApiService";
import { handleEyeClick } from "../../../shared/utils/fileDownload";
import viewIcon from "../../../assets/view-icon.png";
import greenCheck from "../../../assets/green-check.png";
import deleteIcon from "../../../assets/delete-icon.png";
import { toast } from "react-toastify";

const OtherDetails = ({
  applicationId,
  formData,
  setFormData,
  handleChange,
  errors,
  handleReferenceChange,
}) => {
  return (
    <>
      {/* Other Details */}
      <div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5">
        {/* <p
                    className="tab_headers"
                    style={{ marginBottom: "0px", marginTop: "1rem" }}
                >
                    Other Details
                </p> */}

        <div className="section-header">
          <span className="section-header-title">Additional Details</span>
        </div>

        <div className="col-md-12">
          <label className="form-label">
            Mark of Identification<span className="text-danger">*</span>
          </label>
          <textarea
            rows="1"
            placeholder="Enter mark of identification"
            className={`form-control onboarding-input ${errors?.markOfIdentification ? "is-invalid" : ""}`}
            name="markOfIdentification"
            value={
              formData.preOnboardingOtherDetails.markOfIdentification || ""
            }
            onChange={handleChange}
          />
          {errors?.markOfIdentification && (
            <small className="text-danger">{errors.markOfIdentification}</small>
          )}
        </div>

        <div className="col-md-12">
          <label className="form-label">
            Give details of any practical training you completed as part of your
            academic career or training<span className="text-danger">*</span>
          </label>
          <textarea
            rows="1"
            placeholder="Enter practical training details"
            className={`form-control onboarding-input ${errors?.practicalTraining ? "is-invalid" : ""}`}
            name="practicalTraining"
            value={formData.preOnboardingOtherDetails.practicalTraining || ""}
            onChange={handleChange}
          />
          {errors?.practicalTraining && (
            <small className="text-danger">{errors.practicalTraining}</small>
          )}
        </div>

        <div className="col-md-12">
          <label className="form-label">
            Do you have any publications to your credit (papers, articles,
            etc.)? If yes, please provide details
            <span className="text-danger">*</span>
          </label>
          <textarea
            rows="1"
            placeholder="Enter publication details"
            className={`form-control onboarding-input ${errors?.publications ? "is-invalid" : ""}`}
            name="publications"
            value={formData.preOnboardingOtherDetails.publications || ""}
            onChange={handleChange}
          />
          {errors?.publications && (
            <small className="text-danger">{errors.publications}</small>
          )}
        </div>

        <div className="col-md-12">
          <label className="form-label">
            Are you currently studying for any further course? If yes, please
            provide details.<span className="text-danger">*</span>
          </label>
          <textarea
            rows="1"
            placeholder="Enter future course details"
            className={`form-control onboarding-input ${errors?.futureCourse ? "is-invalid" : ""}`}
            name="futureCourse"
            value={formData.preOnboardingOtherDetails.futureCourse || ""}
            onChange={handleChange}
          />
          {errors?.futureCourse && (
            <small className="text-danger">{errors.futureCourse}</small>
          )}
        </div>

        <div className="col-md-12">
          <label className="form-label">
            Are you a member of any professional or political body? If yes,
            please provide details<span className="text-danger">*</span>
          </label>
          <textarea
            rows="1"
            placeholder="Enter professional membership details"
            className={`form-control onboarding-input ${errors?.professionalMembership ? "is-invalid" : ""}`}
            name="professionalMembership"
            value={
              formData.preOnboardingOtherDetails.professionalMembership || ""
            }
            onChange={handleChange}
          />
          {errors?.professionalMembership && (
            <small className="text-danger">
              {errors.professionalMembership}
            </small>
          )}
        </div>

        <div className="col-md-12">
          <label className="form-label">
            Have you ever been arrested, detained, bound, fined, convicted by
            law, debarred or disqualified from any examination (including those
            conducted by a public service commission), or restricted by any
            authority/institution? If yes, please provide full details
            <span className="text-danger">*</span>
          </label>
          <textarea
            rows="1"
            placeholder="Enter legal history details"
            className={`form-control onboarding-input ${errors?.legalHistory ? "is-invalid" : ""}`}
            name="legalHistory"
            value={formData.preOnboardingOtherDetails.legalHistory || ""}
            onChange={handleChange}
          />
          {errors?.legalHistory && (
            <small className="text-danger">{errors.legalHistory}</small>
          )}
        </div>

        <div className="col-md-12">
          <label className="form-label">
            Any other information you would like to provide?
            <span className="text-danger">*</span>
          </label>
          <textarea
            rows="1"
            placeholder="Enter other information"
            className={`form-control onboarding-input ${errors?.otherInformation ? "is-invalid" : ""}`}
            name="otherInformation"
            value={formData.preOnboardingOtherDetails.otherInformation || ""}
            onChange={handleChange}
          />
          {errors?.otherInformation && (
            <small className="text-danger">{errors.otherInformation}</small>
          )}
        </div>
      </div>

      {/* References Details */}
      <div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5">
        <div className="section-header">
          <span className="section-header-title">
            Introduced By (References)
          </span>
        </div>

        <p
          className="tab_headers"
          style={{ marginBottom: "0px", marginTop: "1rem" }}
        >
          References Details 1
        </p>
        <div className="col-lg-3 col-md-6">
          <label>
            Name <span className="text-danger">*</span>
          </label>

          <input
            type="text"
            placeholder="Enter name"
            className={`form-control onboarding-input ${
              errors?.[0]?.referenceName ? "is-invalid" : ""
            }`}
            value={formData.preOnboardingReferences?.[0]?.referenceName || ""}
            onChange={(e) =>
              handleReferenceChange(
                0,
                "referenceName",
                e.target.value.replace(/[^A-Za-z ]/g, ""),
              )
            }
          />
          {errors?.[0]?.referenceName && (
            <small className="text-danger">{errors[0].referenceName}</small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label>
            Designation <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter designation"
            className={`form-control onboarding-input ${
              errors?.[0]?.referenceDesignation ? "is-invalid" : ""
            }`}
            name="referenceDesignation"
            value={
              formData.preOnboardingReferences?.[0]?.referenceDesignation || ""
            }
            onChange={(e) =>
              handleReferenceChange(
                0,
                "referenceDesignation",
                e.target.value.replace(/[^A-Za-z ]/g, ""),
              )
            }
            required
          />
          {errors?.[0]?.referenceDesignation && (
            <small className="text-danger">
              {errors[0].referenceDesignation}
            </small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label>
            Organisation <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter organisation"
            className={`form-control onboarding-input ${
              errors?.[0]?.referenceOrganisation ? "is-invalid" : ""
            }`}
            name="referenceOrganisation"
            value={
              formData.preOnboardingReferences?.[0]?.referenceOrganisation || ""
            }
            onChange={(e) =>
              handleReferenceChange(
                0,
                "referenceOrganisation",
                e.target.value.replace(/[^A-Za-z0-9 .,&()-]/g, ""),
              )
            }
            required
          />
          {errors?.[0]?.referenceOrganisation && (
            <small className="text-danger">
              {errors[0].referenceOrganisation}
            </small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label>
            Contact Number <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter contact number"
            maxLength={10}
            className={`form-control onboarding-input ${
              errors?.[0]?.referenceContact ? "is-invalid" : ""
            }`}
            name="referenceContact"
            value={
              formData.preOnboardingReferences?.[0]?.referenceContact || ""
            }
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");

              handleReferenceChange(0, "referenceContact", value);
            }}
            required
          />
          {errors?.[0]?.referenceContact && (
            <small className="text-danger">{errors[0].referenceContact}</small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label>
            Email ID <span className="text-danger">*</span>
          </label>
          <input
            type="email"
            placeholder="Enter email ID"
            className={`form-control onboarding-input ${
              errors?.[0]?.referenceEmail ? "is-invalid" : ""
            }`}
            name="referenceEmail"
            value={formData.preOnboardingReferences?.[0]?.referenceEmail || ""}
            onChange={(e) =>
              handleReferenceChange(
                0,
                "referenceEmail",
                e.target.value.replace(/\s/g, "").toLowerCase(),
              )
            }
            required
          />
          {errors?.[0]?.referenceEmail && (
            <small className="text-danger">{errors[0].referenceEmail}</small>
          )}
        </div>

        {/* Upload Document */}
        <div className="col-lg-3 col-md-6">
          <label>
            Upload Your Documents <span className="text-danger">*</span>
          </label>

          {!formData.preOnboardingReferences?.[0]?.referenceDocumentUrl ? (
            <>
              <div
                className={`border rounded d-flex flex-column align-items-center justify-content-center ${
                  errors?.[0]?.referenceDocument ? "border-danger" : ""
                }`}
                style={{
                  minHeight: "100px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  document.getElementById("otherDocumentInput1").click()
                }
              >
                <FontAwesomeIcon icon={faUpload} className="text-secondary" />

                <div
                  className="mt-2"
                  style={{
                    color: "#7b7b7b",
                    fontWeight: "500",
                  }}
                >
                  Click to upload
                </div>

                <div className="text-muted" style={{ fontSize: "12px" }}>
                  PDF, JPG or PNG (Max 2MB)
                </div>

                <input
                  id="otherDocumentInput1"
                  type="file"
                  accept=".jpg,.jpeg,.png,.pdf"
                  style={{ display: "none" }}
                  onChange={async (e) => {
                    const file = e.target.files?.[0];
                    if (!file) return;

                    const allowedTypes = [
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                      "application/pdf",
                    ];

                    if (!allowedTypes.includes(file.type)) {
                      toast.error(
                        "Only JPG, JPEG, PNG and PDF files are allowed",
                      );
                      e.target.value = "";
                      return;
                    }

                    if (file.size > 2 * 1024 * 1024) {
                      toast.error("File size should not exceed 2 MB");
                      e.target.value = "";
                      return;
                    }

                    try {
                      const response = await jobsApiService.uploadOtherFile(
                        applicationId,
                        "REFERENCE_PROOF",
                        file,
                      );

                      const uploadedDoc = response.data;

                      handleReferenceChange(0, "referenceDocument", file);
                      handleReferenceChange(
                        0,
                        "referenceDocumentType",
                        uploadedDoc.documentType,
                      );
                      handleReferenceChange(
                        0,
                        "referenceDocumentUrl",
                        uploadedDoc.documentUrl,
                      );
                      handleReferenceChange(
                        0,
                        "referenceDocumentId",
                        uploadedDoc.id,
                      );
                      handleReferenceChange(0, "isNew", true);
                    } catch (err) {
                      console.error("Reference upload failed:", err);
                    }
                  }}
                />
              </div>

              {/* Validation message outside the upload box */}
              {errors?.[0]?.referenceDocument && (
                <small className="text-danger d-block mt-1">
                  {errors[0].referenceDocument}
                </small>
              )}
            </>
          ) : (
            // Uploaded file UI

            <div
              className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
              style={{
                border: "2px solid #bfc8e2",
                borderRadius: "8px",
                background: "#f7f9fc",
              }}
            >
              <div className="d-flex align-items-center">
                <img
                  src={greenCheck}
                  alt="check"
                  style={{
                    width: "22px",
                    height: "22px",
                    marginRight: "10px",
                  }}
                />

                <div>
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#42579f",
                    }}
                  >
                    {
                      formData.preOnboardingReferences?.[0]
                        ?.referenceDocumentType
                    }
                  </div>

                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    {formData.preOnboardingReferences?.[0]?.referenceDocument
                      ?.size
                      ? `${(
                          formData.preOnboardingReferences[0].referenceDocument
                            .size / 1024
                        ).toFixed(1)} KB`
                      : ""}
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2">
                <img
                  src={viewIcon}
                  alt="View"
                  style={{
                    width: "25px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleEyeClick(
                      formData.preOnboardingReferences?.[0]
                        ?.referenceDocumentUrl,
                    )
                  }
                />

                <img
                  src={deleteIcon}
                  alt="Delete"
                  style={{
                    width: "25px",
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    if (
                      formData.preOnboardingReferences?.[0]?.referenceDocumentId
                    ) {
                      await jobsApiService.deleteQualificationFile(
                        formData.preOnboardingReferences[0].referenceDocumentId,
                      );
                    }

                    handleReferenceChange(0, "referenceDocument", null);
                    handleReferenceChange(0, "referenceDocumentName", "");
                    handleReferenceChange(0, "referenceDocumentUrl", "");
                    handleReferenceChange(0, "referenceDocumentId", "");
                    handleReferenceChange(0, "isNew", false);
                  }}
                />
              </div>
            </div>
          )}
        </div>

        {/* Passport Photo */}
        {/* <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Passport Size Photograph
                    </label>

                    {!formData.preOnboardingReferences?.[0]?.passportPhoto ? (
                        <div
                            className="border rounded d-flex flex-column align-items-center justify-content-center"
                            style={{
                                minHeight: "100px",
                                cursor: "pointer"
                            }}
                            onClick={() =>
                                document
                                    .getElementById("passportPhotoInput1")
                                    .click()
                            }
                        >
                            <FontAwesomeIcon
                                icon={faUpload}
                                className="text-secondary"
                            />

                            <div
                                className="mt-2"
                                style={{
                                    color: "#7b7b7b",
                                    fontWeight: "500"
                                }}
                            >
                                Upload Your Latest Passport Size Photograph
                            </div>

                            <div
                                className="text-muted"
                                style={{ fontSize: "12px" }}
                            >
                                PDF, JPG or PNG (Max 2MB)
                            </div>

                            <input
                                id="passportPhotoInput1"
                                type="file"
                                accept=".jpg,.jpeg,.png,.pdf"
                                style={{ display: "none" }}
                                onChange={(e) =>
                                    handleReferenceChange(
                                        0,
                                        "passportPhoto",
                                        e.target.files[0]
                                    )
                                }
                            />
                        </div>
                    ) : (
                        <div
                            className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                            style={{
                                border: "2px solid #bfc8e2",
                                borderRadius: "8px",
                                background: "#f7f9fc"
                            }}
                        >
                            <div className="d-flex align-items-center">
                                <img
                                    src={greenCheck}
                                    alt="check"
                                    style={{
                                        width: "22px",
                                        height: "22px",
                                        marginRight: "10px"
                                    }}
                                />

                                <div>
                                    <div
                                        style={{
                                            fontWeight: 600,
                                            color: "#42579f"
                                        }}
                                    >
                                        {formData.preOnboardingReferences?.[0]?.passportPhoto?.name}
                                    </div>

                                    <div
                                        className="text-muted"
                                        style={{ fontSize: "12px" }}
                                    >
                                        {(
                                            formData.preOnboardingReferences?.[0]?.passportPhoto?.size / 1024
                                        ).toFixed(1)} KB
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex gap-2">
                                <img
                                    src={viewIcon}
                                    alt="View"
                                    style={{
                                        width: "25px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        window.open(
                                            URL.createObjectURL(
                                                formData.preOnboardingReferences?.[0]?.passportPhoto
                                            ),
                                            "_blank"
                                        )
                                    }
                                />

                                <img
                                    src={deleteIcon}
                                    alt="Delete"
                                    style={{
                                        width: "25px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        handleReferenceChange(
                                            0,
                                            "passportPhoto",
                                            null
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
                </div> */}

        <p
          className="tab_headers mt-4"
          style={{ marginBottom: "0px", marginTop: "1rem" }}
        >
          Reference Details 2
        </p>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter name"
            className={`form-control onboarding-input ${errors?.[1]?.referenceName ? "is-invalid" : ""}`}
            name="referenceName"
            value={formData.preOnboardingReferences?.[1]?.referenceName || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/[^A-Za-z ]/g, "");

              handleReferenceChange(1, "referenceName", value);
            }}
            required
          />
          {errors?.[1]?.referenceName && (
            <small className="text-danger">{errors[1].referenceName}</small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Designation <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter designation"
            className={`form-control onboarding-input ${errors?.[1]?.referenceDesignation ? "is-invalid" : ""}`}
            name="referenceDesignation"
            value={
              formData.preOnboardingReferences?.[1]?.referenceDesignation || ""
            }
            onChange={(e) =>
              handleReferenceChange(1, "referenceDesignation", e.target.value)
            }
            required
          />
          {errors?.[1]?.referenceDesignation && (
            <small className="text-danger">
              {errors[1].referenceDesignation}
            </small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Organisation <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter organisation"
            className={`form-control onboarding-input ${errors?.[1]?.referenceOrganisation ? "is-invalid" : ""}`}
            name="referenceOrganisation"
            value={
              formData.preOnboardingReferences?.[1]?.referenceOrganisation || ""
            }
            onChange={(e) =>
              handleReferenceChange(1, "referenceOrganisation", e.target.value)
            }
            required
          />
          {errors?.[1]?.referenceOrganisation && (
            <small className="text-danger">
              {errors[1].referenceOrganisation}
            </small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Contact Number <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter contact number"
            maxLength={10}
            className={`form-control onboarding-input ${errors?.[1]?.referenceContact ? "is-invalid" : ""}`}
            name="referenceContact"
            value={
              formData.preOnboardingReferences?.[1]?.referenceContact || ""
            }
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");

              handleReferenceChange(1, "referenceContact", value);
            }}
            required
          />
          {errors?.[1]?.referenceContact && (
            <small className="text-danger">{errors[1].referenceContact}</small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Email ID <span className="text-danger">*</span>
          </label>
          <input
            type="email"
            placeholder="Enter email ID"
            className={`form-control onboarding-input ${errors?.[1]?.referenceEmail ? "is-invalid" : ""}`}
            name="referenceEmail"
            value={formData.preOnboardingReferences?.[1]?.referenceEmail || ""}
            onChange={(e) =>
              handleReferenceChange(1, "referenceEmail", e.target.value)
            }
            required
          />
          {errors?.[1]?.referenceEmail && (
            <small className="text-danger">{errors[1].referenceEmail}</small>
          )}
        </div>

        {/* Upload Document */}
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Upload Your Documents <span className="text-danger">*</span>
          </label>

          {!formData.preOnboardingReferences?.[1]?.referenceDocumentUrl ? (
            <>
              <div
                className={`border rounded d-flex flex-column align-items-center justify-content-center ${
                  errors?.[1]?.referenceDocument ? "border-danger" : ""
                }`}
                style={{
                  minHeight: "100px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  document.getElementById("otherDocumentInput2").click()
                }
              >
                <FontAwesomeIcon icon={faUpload} className="text-secondary" />

                <div
                  className="mt-2"
                  style={{
                    color: "#7b7b7b",
                    fontWeight: "500",
                  }}
                >
                  Click to upload
                </div>

                <div className="text-muted" style={{ fontSize: "12px" }}>
                  PDF, JPG or PNG (Max 2MB)
                </div>

                <input
                  id="otherDocumentInput2"
                  type="file"
                  accept=".jpg,.jpeg,.png,.pdf"
                  style={{ display: "none" }}
                  onChange={async (e) => {
                    const file = e.target.files?.[0];
                    if (!file) return;

                    const allowedTypes = [
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                      "application/pdf",
                    ];

                    if (!allowedTypes.includes(file.type)) {
                      toast.error(
                        "Only JPG, JPEG, PNG and PDF files are allowed",
                      );
                      e.target.value = "";
                      return;
                    }

                    if (file.size > 2 * 1024 * 1024) {
                      toast.error("File size should not exceed 2 MB");
                      e.target.value = "";
                      return;
                    }

                    try {
                      const response = await jobsApiService.uploadOtherFile(
                        applicationId,
                        "REFERENCE_PROOF",
                        file,
                      );

                      const uploadedDoc = response.data;

                      handleReferenceChange(1, "referenceDocument", file);
                      handleReferenceChange(
                        1,
                        "referenceDocumentType",
                        uploadedDoc.documentType,
                      );
                      handleReferenceChange(
                        1,
                        "referenceDocumentUrl",
                        uploadedDoc.documentUrl,
                      );
                      handleReferenceChange(
                        1,
                        "referenceDocumentId",
                        uploadedDoc.id,
                      );
                      handleReferenceChange(1, "isNew", true);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                />
              </div>

              {/* Validation outside the upload box */}
              {errors?.[1]?.referenceDocument && (
                <small className="text-danger d-block mt-1">
                  {errors[1].referenceDocument}
                </small>
              )}
            </>
          ) : (
            // Uploaded file UI

            <div
              className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
              style={{
                border: "2px solid #bfc8e2",
                borderRadius: "8px",
                background: "#f7f9fc",
              }}
            >
              <div className="d-flex align-items-center">
                <img
                  src={greenCheck}
                  alt="check"
                  style={{
                    width: "22px",
                    height: "22px",
                    marginRight: "10px",
                  }}
                />

                <div>
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#42579f",
                    }}
                  >
                    {
                      formData.preOnboardingReferences?.[1]
                        ?.referenceDocumentType
                    }
                  </div>

                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    {formData.preOnboardingReferences?.[1]?.referenceDocument
                      ?.size
                      ? `${(
                          formData.preOnboardingReferences[1].referenceDocument
                            .size / 1024
                        ).toFixed(1)} KB`
                      : ""}
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2">
                <img
                  src={viewIcon}
                  alt="View"
                  style={{
                    width: "25px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleEyeClick(
                      formData.preOnboardingReferences?.[1]
                        ?.referenceDocumentUrl,
                    )
                  }
                />

                <img
                  src={deleteIcon}
                  alt="Delete"
                  style={{
                    width: "25px",
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    if (
                      formData.preOnboardingReferences?.[1]?.referenceDocumentId
                    ) {
                      await jobsApiService.deleteQualificationFile(
                        formData.preOnboardingReferences[1].referenceDocumentId,
                      );
                    }

                    handleReferenceChange(1, "referenceDocument", null);
                    handleReferenceChange(1, "referenceDocumentName", "");
                    handleReferenceChange(1, "referenceDocumentUrl", "");
                    handleReferenceChange(1, "referenceDocumentId", "");
                    handleReferenceChange(1, "isNew", false);
                  }}
                />
              </div>
            </div>
          )}
        </div>
        {/* Passport Photo */}
        {/* <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Passport Size Photograph
                    </label>

                    {!formData.preOnboardingReferences?.[1]?.passportPhoto ? (
                        <div
                            className="border rounded d-flex flex-column align-items-center justify-content-center"
                            style={{
                                minHeight: "100px",
                                cursor: "pointer"
                            }}
                            onClick={() =>
                                document
                                    .getElementById("passportPhotoInput2")
                                    .click()
                            }
                        >
                            <FontAwesomeIcon
                                icon={faUpload}
                                className="text-secondary"
                            />

                            <div
                                className="mt-2"
                                style={{
                                    color: "#7b7b7b",
                                    fontWeight: "500"
                                }}
                            >
                                Upload Your Latest Passport Size Photograph
                            </div>

                            <div
                                className="text-muted"
                                style={{ fontSize: "12px" }}
                            >
                                PDF, JPG or PNG (Max 2MB)
                            </div>

                            <input
                                id="passportPhotoInput2"
                                type="file"
                                accept=".jpg,.jpeg,.png,.pdf"
                                style={{ display: "none" }}
                                onChange={(e) =>
                                    handleReferenceChange(
                                        1,
                                        "passportPhoto",
                                        e.target.files[0]
                                    )
                                }
                            />
                        </div>
                    ) : (
                        <div
                            className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                            style={{
                                border: "2px solid #bfc8e2",
                                borderRadius: "8px",
                                background: "#f7f9fc"
                            }}
                        >
                            <div className="d-flex align-items-center">
                                <img
                                    src={greenCheck}
                                    alt="check"
                                    style={{
                                        width: "22px",
                                        height: "22px",
                                        marginRight: "10px"
                                    }}
                                />

                                <div>
                                    <div
                                        style={{
                                            fontWeight: 600,
                                            color: "#42579f"
                                        }}
                                    >
                                        {formData.preOnboardingReferences?.[1]?.passportPhoto?.name}
                                    </div>

                                    <div
                                        className="text-muted"
                                        style={{ fontSize: "12px" }}
                                    >
                                        {(
                                            formData.preOnboardingReferences?.[1]?.passportPhoto?.size / 1024
                                        ).toFixed(1)} KB
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex gap-2">
                                <img
                                    src={viewIcon}
                                    alt="View"
                                    style={{
                                        width: "25px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        window.open(
                                            URL.createObjectURL(
                                                formData.preOnboardingReferences?.[1]?.passportPhoto
                                            ),
                                            "_blank"
                                        )
                                    }
                                />

                                <img
                                    src={deleteIcon}
                                    alt="Delete"
                                    style={{
                                        width: "25px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        handleReferenceChange(
                                            1,
                                            "passportPhoto",
                                            null
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
                </div> */}
      </div>
    </>
  );
};

export default OtherDetails;
